import { AustralianState } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';

export const useFormRegion = () => {
  const { selectedForm } = useAppSelector((state) => state.form);

  return selectedForm?.state as AustralianState | undefined;
};
